// =============================================================================
// System Health Hook
// =============================================================================

import { useState, useCallback, useEffect } from 'react';
import { apiClient } from '../services/apiClient';

export function useSystemHealth() {
  const [isHealthy, setIsHealthy] = useState(true);
  const [healthData, setHealthData] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);

  const checkHealth = useCallback(async () => {
    setIsChecking(true);
    
    try {
      const health = await apiClient.healthCheck();
      
      setHealthData(health);
      setIsHealthy(health.status === 'healthy');
      setLastCheck(new Date());
      
      return health;
    } catch (error) {
      console.error('Health check failed:', error);
      setIsHealthy(false);
      setHealthData({
        status: 'unhealthy',
        error: error.message,
        timestamp: new Date().toISOString()
      });
      setLastCheck(new Date());
      
      return null;
    } finally {
      setIsChecking(false);
    }
  }, []);

  // Periodic health checks
  useEffect(() => {
    // Initial health check
    checkHealth();
    
    // Set up periodic checks every 30 seconds
    const interval = setInterval(checkHealth, 30000);
    
    return () => clearInterval(interval);
  }, [checkHealth]);

  return {
    isHealthy,
    healthData,
    isChecking,
    lastCheck,
    checkHealth
  };
}
